import { render, staticRenderFns } from "./ListNumberOrder.vue?vue&type=template&id=c145ce16&scoped=true&"
import script from "./ListNumberOrder.vue?vue&type=script&lang=js&"
export * from "./ListNumberOrder.vue?vue&type=script&lang=js&"
import style0 from "./ListNumberOrder.vue?vue&type=style&index=0&id=c145ce16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c145ce16",
  null
  
)

export default component.exports